import { dispatchPromise } from './action-helpers';

export const fetchConfig = () => {
    return dispatchPromise({
        type: 'FLYOUT_CONFIG_FETCH_REQUESTED'
    });
}

export const openFlyout = (flyoutId, flyoutProps) => {
    return dispatchPromise({
        type: 'FLYOUT_OPEN_REQUESTED',
        payload: {
            flyoutId,
            flyoutProps
        }
    });
}

export const closeFlyout = () => {
    return dispatchPromise({
        type: 'FLYOUT_CLOSE_REQUESTED',
        payload: null
    });
}
